import setHexWithAlphaToSolid from "./setHexWithAlphaToSolid";
import setTextColorBasedOnBg from "./setTextColorBasedOnBg";
import setWebToTextStyles from "./setWebToTextStyles";

const setEpWindowStyles = (root, epStyleConfig) => {
    const { rdChat, exitPopupChat, isRDPlusTheme, webToText = {} } = epStyleConfig;
    root.documentElement.style.setProperty('--headerColor', rdChat.general.headerColor);
    root.documentElement.style.setProperty('--sendbuttonColor', exitPopupChat.sendButton.sendbuttonBackgroundColor);
    root.documentElement.style.setProperty(
        '--leftBarBackground1Color',
        exitPopupChat.general.leftBarBackground1Color
    );
    root.documentElement.style.setProperty(
        '--leftBarBackground2Color',
        exitPopupChat.general.leftBarBackground2Color
    );
    root.documentElement.style.setProperty(
        '--leftBarBackground1ColorTop',
        exitPopupChat.general.leftBarBackground1Color.concat(' 0%')
    );
    root.documentElement.style.setProperty(
        '--leftBarBackground2ColorTop',
        exitPopupChat.general.leftBarBackground2Color.concat(' 100%')
    );

    root.documentElement.style.setProperty(
        '--participantsFontColor',
        exitPopupChat.header.participantsFont.color
    );
    root.documentElement.style.setProperty(
        '--participantsFontSize',
        exitPopupChat.header.participantsFont.size
    );
    root.documentElement.style.setProperty(
        '--participantsFontFamily',
        exitPopupChat.header.participantsFont.family
    );
    root.documentElement.style.setProperty(
        '--patiicipantsFontitalic',
        exitPopupChat.header.participantsFont.italic
    );
    root.documentElement.style.setProperty(
        '--patiicipantsFontbold',
        exitPopupChat.header.participantsFont.bold
    );
    root.documentElement.style.setProperty(
        '--patiicipantsFontunderline',
        exitPopupChat.header.participantsFont.underline
    );

    root.documentElement.style.setProperty(
        '--phoneFontColor',
        exitPopupChat.general.phoneFontField.color
    );
    root.documentElement.style.setProperty(
        '--phoneFontSize',
        exitPopupChat.general.phoneFontField.size
    );
    root.documentElement.style.setProperty(
        '--phoneFontFamily',
        exitPopupChat.general.phoneFontField.family
    );
    root.documentElement.style.setProperty(
        '--phoneFontitalic',
        exitPopupChat.general.phoneFontField.italic
    );
    root.documentElement.style.setProperty(
        '--phoneFontbold',
        exitPopupChat.general.phoneFontField.bold
    );
    root.documentElement.style.setProperty(
        '--phoneFontunderline',
        exitPopupChat.general.phoneFontField.underline
    );
    if (exitPopupChat.enableBranding) {
        root.documentElement.style.setProperty('--btnClose', exitPopupChat.general.btnClose);

        root.documentElement.style.setProperty(
            '--disclaimerFontColor',
            exitPopupChat.general.disclaimerFont.color
        );
        root.documentElement.style.setProperty(
            '--brandingLeftBarBackground1Color',
            exitPopupChat.general.leftBarBackground1Color
        );
        root.documentElement.style.setProperty(
            '--brandingBtnClose',
            exitPopupChat.general.brandingBtnClose
        );
        root.documentElement.style.setProperty(
            '--brandingOpacityBrandColor',
            exitPopupChat.general.opacityBrandColor
        );
        root.documentElement.style.setProperty(
            '--brandingleftBarBackground1ColorSelect',
            exitPopupChat.general.leftBarBackground1Color
        );
        root.documentElement.style.setProperty(
            '--opacityBrandColor',
            exitPopupChat.general.opacityBrandColor
        );
    } else {
        root.documentElement.style.setProperty('--brandingBtnClose', '#EBF8FF');
        root.documentElement.style.setProperty('--brandingLeftBarBackground1Color', '#0056D0');
        root.documentElement.style.setProperty(
            '--brandingleftBarBackground1ColorSelect',
            '#83570E'
        );
    }
    root.documentElement.style.setProperty(
        '--disclaimerFontSize',
        exitPopupChat.footer.disclaimerFont.size
    );
    root.documentElement.style.setProperty(
        '--disclaimerFontFamily',
        exitPopupChat.footer.disclaimerFont.family
    );
    root.documentElement.style.setProperty(
        '--disclaimerFontitalic',
        exitPopupChat.footer.disclaimerFont.italic ? 'italic' : 'normal'
    );
    root.documentElement.style.setProperty(
        '--disclaimerFontbold',
        exitPopupChat.footer.disclaimerFont.bold ? 'bold' : 'normal'
    );
    root.documentElement.style.setProperty(
        '--disclaimerFontunderline',
        exitPopupChat.footer.disclaimerFont.underline ? 'underline' : 'unset'
    );
    root.documentElement.style.setProperty(
        '--disclaimerBgColor',
        exitPopupChat.general.disclaimerBgColor || "#F3F3F3"
    );

    root.documentElement.style.setProperty('--agentBgColor', rdChat.messages.agentBgColor);

    root.documentElement.style.setProperty(
        '--agentFontFieldColor',
        exitPopupChat.messages.agentFontField.color
    );
    root.documentElement.style.setProperty(
        '--agentFontFieldFontSize',
        exitPopupChat.messages.agentFontField.size
    );
    root.documentElement.style.setProperty(
        '--agentFontFieldFontFamily',
        exitPopupChat.messages.agentFontField.family
    );
    root.documentElement.style.setProperty(
        '--agentFontFielditalic',
        exitPopupChat.messages.agentFontField.italic
    );
    root.documentElement.style.setProperty(
        '--agentFontFieldbold',
        exitPopupChat.messages.agentFontField.bold
    );
    root.documentElement.style.setProperty(
        '--agentFontFieldunderline',
        exitPopupChat.messages.agentFontField.underline
    );

    root.documentElement.style.setProperty(
        '--visitorFontColor',
        exitPopupChat.messages.visitorFontField.color
    );
    root.documentElement.style.setProperty(
        '--visitorFontSize',
        exitPopupChat.messages.visitorFontField.size
    );
    root.documentElement.style.setProperty(
        '--visitorFontFamily',
        exitPopupChat.messages.visitorFontField.family
    );
    root.documentElement.style.setProperty(
        '--visitorFontitalic',
        exitPopupChat.messages.visitorFontField.italic
    );
    root.documentElement.style.setProperty(
        '--visitorFontbold',
        exitPopupChat.messages.visitorFontField.bold
    );
    root.documentElement.style.setProperty(
        '--visitorFontunderline',
        exitPopupChat.messages.visitorFontField.underline
    );

    root.documentElement.style.setProperty(
        '--visitorFontFieldColor',
        exitPopupChat.messages.visitorFontField.color
    );
    root.documentElement.style.setProperty(
        '--visitorFontFieldFontSize',
        exitPopupChat.messages.visitorFontField.size
    );
    root.documentElement.style.setProperty(
        '--visitorFontFieldFontFamily',
        exitPopupChat.messages.visitorFontField.family
    );
    root.documentElement.style.setProperty(
        '--visitorFontFielditalic',
        exitPopupChat.messages.visitorFontField.italic
    );
    root.documentElement.style.setProperty(
        '--visitorFontFieldbold',
        exitPopupChat.messages.visitorFontField.bold
    );
    root.documentElement.style.setProperty(
        '--visitorFontFieldunderline',
        exitPopupChat.messages.visitorFontField.underline
    );

    root.documentElement.style.setProperty(
        '--powerByFontColor',
        exitPopupChat.footer.poweredByFont.color
    );
    root.documentElement.style.setProperty(
        '--powerByFontSize',
        exitPopupChat.footer.poweredByFont.size
    );
    root.documentElement.style.setProperty(
        '--powerByFontFamily',
        exitPopupChat.footer.poweredByFont.family
    );
    root.documentElement.style.setProperty(
        '--powerByFontitalic',
        exitPopupChat.footer.poweredByFont.italic
    );
    root.documentElement.style.setProperty(
        '--powerByFontbold',
        exitPopupChat.footer.poweredByFont.bold
    );
    root.documentElement.style.setProperty(
        '--powerByFontunderline',
        exitPopupChat.footer.poweredByFont.underline
    );

    root.documentElement.style.setProperty(
        '--headerTitleFontColor',
        exitPopupChat.header.titleFont.color
    );
    root.documentElement.style.setProperty(
        '--headerTitleFontSize',
        exitPopupChat.header.titleFont.size
    );
    root.documentElement.style.setProperty(
        '--headerTitleFontFamily',
        exitPopupChat.header.titleFont.family
    );
    root.documentElement.style.setProperty(
        '--headerTitleFontitalic',
        exitPopupChat.header.titleFont.italic
    );
    root.documentElement.style.setProperty(
        '--headerTitleFontbold',
        exitPopupChat.header.titleFont.bold
    );
    root.documentElement.style.setProperty(
        '--headerTitleFontunderline',
        exitPopupChat.header.titleFont.underline
    );

    root.documentElement.style.setProperty(
        '--typingIndicatorFontColor',
        exitPopupChat.body.typingIndicatorFont.color
    );
    root.documentElement.style.setProperty(
        '--sendbuttonBackgroundColor',
        exitPopupChat.sendButton.sendbuttonBackgroundColor
    );
    root.documentElement.style.setProperty(
        '--sendbuttonTextColor',
        setTextColorBasedOnBg(exitPopupChat.sendButton.sendbuttonBackgroundColor)
    );
    root.documentElement.style.setProperty('--qTQuestion', rdChat.questionType.qTQuestion);

    root.documentElement.style.setProperty(
        '--phoneTextField',
        exitPopupChat.general.phoneTextField
    );
    if (exitPopupChat.header.exitPopupOnlineIndicator) {
        root.documentElement.style.setProperty('--exitPopupOnlineIndicator', 'block');
    } else {
        root.documentElement.style.setProperty('--exitPopupOnlineIndicator', 'none');
    }

    if (exitPopupChat.header.hideHeaderLogo) {
        root.documentElement.style.setProperty('--hideHeaderLogoDisplay', 'none');
    } else {
        root.documentElement.style.setProperty('--hideHeaderLogoDisplay', 'block');
    }
    if (exitPopupChat.footer.hidePoweredBySection) {
        root.documentElement.style.setProperty('--hidePoweredByDisplay', 'none');
    } else {
        root.documentElement.style.setProperty('--hidePoweredByDisplay', 'block');
    }
    root.documentElement.style.setProperty('--footerBackgroundColor', exitPopupChat.footer.backgroundColor);
    if (exitPopupChat.messages.visitorFontField.color) {
        root.documentElement.style.setProperty(
            '--visitorFontFieldOpacityColor',
            `${exitPopupChat.messages.visitorFontField.color}0a`
        );
    }
    if (exitPopupChat.messages.visitorFontField.color) {
        const agentFontFieldOpacityColor = `${exitPopupChat.messages.agentFontField.color}0a`;
        root.documentElement.style.setProperty(
            '--agentFontFieldOpacityColor',
            agentFontFieldOpacityColor
        );
    }
    if (exitPopupChat.messages.agentFontField.color) {
        const messageBgColor = `${exitPopupChat.messages.agentFontField.color}0F`;
        root.documentElement.style.setProperty('--messageBgColor', messageBgColor);
    }
    if (exitPopupChat.header.imageShape === 'Circle') {
        root.documentElement.style.setProperty('--imageShape', '50%');
    } else {
        root.documentElement.style.setProperty(
            '--imageShape',
            `${exitPopupChat.header.imageShape.match(/\d/g).join('')}%`
        );
    }

    if (exitPopupChat.header.imageShape === 'Circle') {
        root.documentElement.style.setProperty('--imageShape', '50%');
    } else {
        root.documentElement.style.setProperty(
            '--imageShape',
            `${exitPopupChat.header.imageShape.match(/\d/g).join('')}%`
        );
    }
    root.documentElement.style.setProperty(
        '--sendbuttonBackgroundColorOpacity',
        `${exitPopupChat.sendButton.sendbuttonBackgroundColor}30`
    );
    root.documentElement.style.setProperty(
        '--qTButton',
        `${exitPopupChat.sendButton.sendbuttonBackgroundColor}`
    );
    root.documentElement.style.setProperty('--hallowBtn', exitPopupChat.sendButton.sendbuttonBackgroundColor);

    root.documentElement.style.setProperty(
        '--qTButtonIcon',
        `${exitPopupChat.sendButton.sendbuttonBackgroundColor}`
    );

    root.documentElement.style.setProperty(
        '--qTButtonText',
        `${exitPopupChat.sendButton?.sendbuttonFont?.color}`
    );

    root.documentElement.style.setProperty(
        '--visitorBgColor',
        `${exitPopupChat.messages?.visitorBackgroundColor}`
    );
    root.documentElement.style.setProperty(
        '--visitorFontColor',
        `${exitPopupChat.messages?.visitorFontField?.color}`
    );

    root.documentElement.style.setProperty(
        '--headerFontColor',
        `${exitPopupChat.sendButton?.sendbuttonFont?.color}`
    );

    if (exitPopupChat.header.hideHeaderLogo) {
        root.documentElement.style.setProperty('--hideHeaderLogoOpacity', '0');
    } else {
        root.documentElement.style.setProperty('--hideHeaderLogoOpacity', '1');
    }

    const staticDark = "#020202";

    if (isRDPlusTheme) {
        setWebToTextStyles(root, exitPopupChat.sendButton.sendbuttonBackgroundColor, staticDark, webToText);
    }
    if (exitPopupChat.enableBranding) {

        const brandSolid = exitPopupChat.general.leftBarBackground1Color;
        const visitorMsgBubble = `${brandSolid}b3`;

        root.documentElement.style.setProperty('--sendbuttonColor', brandSolid);
        root.documentElement.style.setProperty('--headerColor', brandSolid);
        root.documentElement.style.setProperty('--brandColor', visitorMsgBubble);
        root.documentElement.style.setProperty('--brandingLeftBarBackground1Color', brandSolid);

        // message bubble
        root.documentElement.style.setProperty('--visitorBgColor', setHexWithAlphaToSolid(visitorMsgBubble));
        root.documentElement.style.setProperty('--visitorFontColor', setTextColorBasedOnBg(brandSolid));

        // left bar
        const textColor = setTextColorBasedOnBg(brandSolid)
        root.documentElement.style.setProperty('--participantsFontColor', textColor);
        root.documentElement.style.setProperty('--headerTitleFontColor', textColor);
        root.documentElement.style.setProperty('--phoneFontColor', textColor);
        root.documentElement.style.setProperty('--powerByFontColor', textColor);
        root.documentElement.style.setProperty('--leftBarBackground1Color', setHexWithAlphaToSolid(brandSolid));
        root.documentElement.style.setProperty('--headerFontColor', textColor);
        root.documentElement.style.setProperty('--qTButtonText', textColor);
        root.documentElement.style.setProperty('--qTBorder', staticDark);
        root.documentElement.style.setProperty('--hallowBtn', staticDark);
        root.documentElement.style.setProperty('--qTButtonIcon', staticDark);

    }

};
export default setEpWindowStyles;
